import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { finalize } from 'rxjs';

import { CatalogService, ProjectHelperService } from '@mirage-projects/cw-commons';
import { CatalogObject, IconDetail, JobSite, Project } from '@mirage-projects/cw-models';

import { CardElement } from '../card-list/card-list.component';

/** Widget to show the last elements opened */
@Component({
    selector: 'cw-last-elements-opened',
    templateUrl: './last-elements-opened.component.html',
    standalone: false,
})
export class LastElementsOpenedComponent implements OnInit {
    cardElements!: CardElement[];
    msgError: string | undefined;
    isLoading = true;

    constructor(
        private catalogService: CatalogService,
        private router: Router,
        private projectHelperService: ProjectHelperService
    ) {}

    ngOnInit(): void {
        this.catalogService
            .getLatestDashboardElements()
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (lastObjects) => {
                    this.cardElements = lastObjects.map((catalogObject) => ({
                        catalogObject,
                        iconDetail: this.getIconDetail(catalogObject),
                    }));
                },
                error: () => (this.msgError = 'DASHBOARD.ERROR_LATEST_ELEMENTS'),
            });
    }

    onClickElement(catalogObject: CatalogObject): void {
        if ((catalogObject as JobSite).dataCount) {
            this.router.navigate([`/site-viewer/${catalogObject.id}`]);
        } else {
            const project = catalogObject as Project;
            this.projectHelperService.openProjectViewer(project.id, project.projectType);
        }
    }

    private getIconDetail(catalogObject: CatalogObject): IconDetail[] | undefined {
        const jobSite = catalogObject as JobSite;
        if (!jobSite.dataCount) {
            return undefined;
        }
        const { scan, referenceData } = jobSite.dataCount;
        return [
            { id: 1, icon: 'new-scanners', value: scan || 0, tooltip: 'JOB_SITE.BROWSER.SCAN_PROJECTS' },
            { id: 2, icon: 'document', value: referenceData || 0, tooltip: 'JOB_SITE.BROWSER.REFERENCE_DATA' },
        ];
    }
}
